import { useApi } from '@/api';
import { EntityName, KpiCard, Page, PageSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';
import LiquidationsTable from './LiquidationsTable';

export default function CorePage() {
  const { ilk } = useParams();

  const [data, error] = useApi({
    url: `/liquidations/${ilk}/overview/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={data.collateral_address}
                size="3"
              />
            }>
            <Heading size="1">{ilk} Liquidations</Heading>
          </EntityName>
        }>
        <Flex flexDirection="column" gap="m">
          <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
            <KpiCard title="Liquidations" data={data} field="auctions" />
            <KpiCard
              title="Collateral Auctioned"
              data={data}
              field="collateral_auctioned_usd"
              options={{
                valueOptions: { currencyValueOptions: { currency: 'USD' } },
                valueTrendOptions: {
                  currencyValueOptions: { currency: 'USD' }
                }
              }}
            />
            <KpiCard
              title="Debt Repaid"
              variant="dai"
              data={data}
              field="debt_repaid"
              options={{
                valueOptions: {
                  currencyValueOptions: {
                    currency: tokensMapping('DAI'),
                    iconSize: '3'
                  }
                }
              }}
            />
          </Flex>
        </Flex>
        <HistoricTabs ilk={ilk} />
        <LiquidationsTable ilk={ilk} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
